import { getIsNullish } from '../../jsUtils';

export const getNumberWithSignView = (
  value?: number | null,
  maximumFractionDigits: number = 3,
): string | null => {
  if (getIsNullish(value)) {
    return null;
  }
  const formatter = new Intl.NumberFormat('en-US', {
    signDisplay: 'exceptZero',
    useGrouping: false,
    maximumFractionDigits,
  });

  return formatter.format(value);
};
